
































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Announcement from "@/models/annoucement/annoucement.Model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import AnnoucementService from "@/services/Annoument.service";
import { PermissionValue } from "@/enums/PermissionValue";
import AnnoucementPublish from "@/models/annoucement/annoucementPublish.Model";
@Component
export default class AnnouncementTable extends GenericBTable<Announcement> {
  annoucementService = new AnnoucementService();
  public id: any;
  constructor() {
    super();
    this.id = 0;
  }
  created() {
    this.permissionValue = PermissionValue.CONVOCATORIAS;
    this.tableConfig.controller = "Annoucements";
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let title = new BTableColumn("title", "table.title", false);
    let dateOpen = new BTableColumn("dateOpen", "table.dateOpen", true);
    let dateEnd = new BTableColumn("dateEnd", "table.dateEnd", true);
    let publish = new BTableColumn("published", "table.published", false);
    title.customTemplate = true;
    publish.customTemplate = true;

    dateOpen.type = BTableColumnType.Date;
    dateEnd.type = BTableColumnType.Date;

    this.tableConfig.insertColumns(title, publish);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }

  public publishAnnoucement(annoucement: AnnoucementPublish) {
    this.$buefy.dialog.confirm({
      title: "Publicar Convocatoria",
      message: "¿Estas seguro que deseas publicar esta convocatoria?",
      cancelText: "Cancelar",
      confirmText: "Publicar",
      type: "is-primary",
      hasIcon: true,
      size: "is-medium",
      onConfirm: () => {
        this.annoucementService.publishAnnoucement(annoucement).then(() => {
          this.id = "";
          this.tableConfig.reload();
          this.operationPublish();
        });
      }
    });
  }
  public declineAnnoucement(annoucement: AnnoucementPublish) {
    this.$buefy.dialog.confirm({
      title: "Rechazar Convocatoria",
      message: "¿Estas seguro que deseas rechazar esta publicación?",
      confirmText: "Rechazar",
      cancelText: "Cancelar",
      type: "is-danger",
      hasIcon: true,
      size: "is-medium",
      onConfirm: () => {
        this.annoucementService.declineAnnoucement(annoucement).then(() => {
          this.id = "";
          this.tableConfig.reload();
          this.noPublish();
        });
      }
    });
  }
}
